import "reflect-metadata";
import { Container } from "inversify";

import ValidationService from "./services/validation.service";
import PerformanceService from "./services/performance.service";
import EnquiryService from "./services/enquiry.service";

const container = new Container();

container.bind<ValidationService>(ValidationService).to(ValidationService);
container.bind<PerformanceService>(PerformanceService).to(PerformanceService);
container.bind<EnquiryService>(EnquiryService).to(EnquiryService);

export default container;
